"use client";

import { useEffect } from "react";
import { supabase } from "@/lib/supabase";

function getSyncMarkerKey(
  userId: string,
  metadata: Record<string, unknown> | null | undefined
) {
  const consentDate =
    metadata && typeof metadata.marketing_consent_date === "string"
      ? metadata.marketing_consent_date
      : "none";

  return `noread_marketing_sync_${userId}_${consentDate}`;
}

export default function MarketingSyncBootstrap() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const sync = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      const token = session?.access_token;
      const user = session?.user;
      if (!token || !user) return;

      const markerKey = getSyncMarkerKey(
        user.id,
        user.user_metadata as Record<string, unknown>
      );

      // Si déjà synchronisé pour cette session, on ne refait pas
      if (localStorage.getItem(markerKey) === "1") return;

      const response = await fetch("/api/marketing/sync", {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) return;

      const payload = (await response.json()) as { synced?: boolean };
      if (payload.synced) {
        localStorage.setItem(markerKey, "1");
      }
    };

    // Premier appel au montage
    const timeout = window.setTimeout(() => {
      void sync();
    }, 600);

    // Rappel à chaque changement d'état auth (connexion Google incluse)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) void sync();
    });

    return () => {
      window.clearTimeout(timeout);
      subscription.unsubscribe();
    };
  }, []);

  return null;
}